import { render, staticRenderFns } from "./CTailwindBtn.vue?vue&type=template&id=0d122c0e&scoped=true"
import script from "./CTailwindBtn.vue?vue&type=script&lang=js"
export * from "./CTailwindBtn.vue?vue&type=script&lang=js"
import style0 from "./CTailwindBtn.vue?vue&type=style&index=0&id=0d122c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d122c0e",
  null
  
)

export default component.exports